export interface IdentityType {
    key: string,
    value: string
}

export const identityTypes : IdentityType[] = [{key:"Paszport", value: "PASZPORT"}, {key:"Dowód", value: "DOWOD"}, {key:"Inny dokument", value:"INNY_DOK"}];